import { HomeState, state as initialState } from '@/modules/Home/store/state';
import { MutationTree } from 'vuex';
import { HOME } from './mutation-types';
import { Widget } from '@/models/Widget';

export const SELECTED_DASHBOARD_KEY = 'selectedDashboardId';

export const mutations: MutationTree<HomeState> = {

    [HOME.SET_HOMEPAGE_COMMUNICATION](state, value) {
        state.communication = value;
    },
    [HOME.RESET](state) {
        sessionStorage.removeItem(SELECTED_DASHBOARD_KEY);
        const { traductions, languesDisponibles, langueSelectionnee, ...rest } = initialState;
        Object.assign(state, rest);
    },
    [HOME.SET_ACTUALITES](state, value) {
        state.actualites = value;
    },
    [HOME.SET_NB_NOUVELLES_ACTUS](state, value) {
        state.nbNouvellesActus = value;
    },
    [HOME.SET_ACTUALITE_OPEN](state, value) {
        state.actualiteOpen = value;
    },
    [HOME.SET_ACTUALITE_LOADING](state, value) {
        state.actualiteLoading = value;
    },
    [HOME.SET_REGISTER_MAIL_LOADING](state, value) {
        state.registerMailLoading = value;
    },
    [HOME.SET_NB_NOUVELLES_RECLAMATIONS](state, value) {
        state.nbNouvellesReclamation = value;
    },
    [HOME.SET_DASHBOARDS](state, value) {
        state.dashboards = value;
    },
    [HOME.SET_SELECTED_DASHBOARD](state, value) {
        state.selectedDashboard = value;
        if (value?.id != null) {
            sessionStorage.setItem(SELECTED_DASHBOARD_KEY, String(value.id));
        } else {
            sessionStorage.removeItem(SELECTED_DASHBOARD_KEY);
        }
    },
    [HOME.SET_CREATED_DASHBOARD](state, value) {
        state.createdDashboard = value;
    },
    [HOME.SET_WIDGETS](state, value) {
        state.widgets = value;
    },
    [HOME.SET_ENREGISTREMENT_EN_COURS](state, value) {
        state.enregistementDashboardEnCours = value;
    },
    [HOME.SET_ENREGISTREMENT_MODALE_EN_COURS](state, value) {
        state.enregistementDashboardEnCours = value;
    },
    [HOME.SET_LIBELLE_DASHBOARD](state, value) {
        if (state.selectedDashboard !== undefined) {
            state.selectedDashboard.libelle = value;
        }
    },
    [HOME.SET_WIDGET_POSITION](state, objet: {widgetPosition: number, widget: Widget}) {
        if (state.selectedDashboard && state.selectedDashboard.widgets) {
            const targetWidget = state.selectedDashboard.widgets.find((w: Widget) => w.id === objet.widget.id);
            if (targetWidget) {
                targetWidget.position = objet.widgetPosition;
            }
        }
    },
    [HOME.OPEN_MODAL_WIDGET](state, value) {
        state.openModaleWidget = value;
    },
    [HOME.SET_DASHBOARD_LOADING](state, value) {
        state.dasboardLoading = value;
    },
    [HOME.SET_LANGUES_DISPONIBLES](state, value) {
        state.languesDisponibles = value;
    },
    [HOME.SET_LANGUE_SELECTIONNEE](state, value) {
        state.langueSelectionnee = value;
    },
    [HOME.SET_TRADUCTIONS](state, value) {
        state.traductions = value;
    },
    [HOME.SET_MODAL_CHOIX_PORTAIL_OUVERTE](state, value) {
        state.modalChoixPortailOuverte = value;
    },
    [HOME.SET_SATISFACTION_CONDITIONS](state, value) {
        state.satisfactionConditions = value;
    },
};
